import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Storage } from 'aws-amplify';
import { useTranslation } from 'react-i18next';
import API from '../../api-graphql';
import AlertDialog from '../UI/AlertDialog';
import UploadForm from '../UploadForm';
import { generateSchema, generateUiSchema } from '../TemplateUpload/jsonSchemaUtils';

import { Paper, LinearProgress, makeStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { CONSTANTS } from '../../constants/constants';

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: '50%',
    margin: 'auto',
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    },
    [theme.breakpoints.down(600 + theme.spacing(6))]: {
      maxWidth: '100%'
    }
  }
}));

const TemplateUpdateView = (props) => {
  const { location: { params }, subgroup } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [input, setInput] = useState(() => { return params ? params.input : null; });
  const [files, setFiles] = useState();
  const [loading, setLoading] = useState(!params);
  const [error, setError] = useState(null);
  const FILE_TYPES_ACCEPTED = ['.docx', '.pdf'];

  useEffect(() => {
    if (input) return;

    API.getTemplate(props.match.params.number)
      .then(result => {
        const input = result.data.getTemplate;

        setInput(input);
        setLoading(false);
      })
      .catch(error => {
        console.error(error);
        setError(t('templateUploadView:genericError'));
      });
  }, []);

  useEffect(() => {
    if (!files || files.lenth < 1) return;

    const error = checkFileExtension();
    if (error) {
      setFiles(null);
      setError(error.customMessage);
      return;
    }

    const reader = new FileReader();
    reader.readAsBinaryString(files[0]);

    let schemaPadre = {
      title: t('templateDragAndDrop:schemaTitle'),
      description: t('templateDragAndDrop:description'),
      type: 'object',
      required: [],
      properties: {
        documento: {
          type: 'object',
          title: 'DOCUMENTO',
          properties: {
            nombre: {
              type: 'string',
              title: 'Nombre'
            },
            descripcion: {
              type: 'string',
              title: 'Descripción'
            }
          },
          required: ['nombre']
        }
      }
    };

    if (/[.]\w{3,4}$/.exec(files[0].name)[0] === '.pdf') {
      setSchema(schemaPadre);
    } else {
      reader.onloadend = async (result) => {
        await generateSchema(result, t)
          .then(schema => {
            setSchema(schema);
          })
          .catch((error) => {
            setError(error.message);
          });
      };
    }
  }, [files]);

  const setSchema = (schema) => {
    input.schema = schema;
    setInput(prev => ({ ...prev, ...input }));
  };

  const checkFileExtension = () => {
    const ext = /[.]\w{3,4}$/.exec(files[0].name)[0];

    if (!ext || !FILE_TYPES_ACCEPTED.includes(ext)) {
      const error = new Error('Wrong Extension');
      error.customMessage = `${t('docUpdate:extensionError')} ${FILE_TYPES_ACCEPTED}`;
      return error;
    }

    return null;
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      e.persist();
      setLoading(true);

      if (error) {
        throw error;
      }

      await Storage.put(input.fileUrl, files[0], { contentType: files[0].type });

      input.schema.title = e.target.name.value;
      input.name = e.target.name.value;
      input.schema.description = e.target.description.value || '';
      input.description = e.target.description.value;
      input.status = CONSTANTS.DOCUMENT.STATUS.INIT;
      input.schema = JSON.stringify(input.schema);
      input.uischema = JSON.stringify(generateUiSchema(JSON.parse(input.schema)));
      input.updatedAt = new Date().toISOString();
      input.defaultValues = null;
      input.defaultValuesForm = null;

      await API.updateTemplate(input, subgroup);
      props.history.push('/template');
    } catch (e) {
      console.error(e);
      setLoading(false);
      setError(t('templateUploadView:genericError'));
    }
  };

  if (loading) {
    return <LinearProgress />;
  }

  return (
    <Paper className={classes.paper}>
      <AlertDialog open={!!error} title='Error' description={error} setOpen={() => setError(null)} />
      <UploadForm
        handleSubmit={handleSubmit}
        handleCancel={props.history.goBack}
        setContent={setFiles}
        accept='.docx,.doc,.pdf'
        title={t('templateUpdateView:title')}
        nameLabel={t('templateUploadView:name')}
        descriptionLabel={t('templateUploadView:description')}
        nameValue={input.name}
        descriptionValue={input.description}
        actionButtonLabel={t('templateUpdateView:actionButton')}
      />
    </Paper>
  );
};

TemplateUpdateView.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  subgroup: PropTypes.string.isRequired

};

const mapStateToProps = (state) => {
  return {
    subgroup: state.config.subgroup
  };
};

export default connect(mapStateToProps, null)(TemplateUpdateView);
